import Icon from "@components/_Revamp/Icon/Icon";
import React from "react";
import { styled } from "@linaria/react";
import { ROUTE_PATH } from "@static/route-paths";
import { Link, useLocation } from "react-router-dom";
import { CONTAINER_SIZE, SCREEN_SIZE } from "@static/screen-size";
import { EVER_GREEN_STEP_LIST, STEPS_LIST } from "@static/content";
import { themeDefault } from "src/theme-revamp";
import BgTree from "@assets/images/evergreen-bg-tree.svg";
import Stepper from "../Stepper";
import ProductOverviewMobile from "../ProductOverViewMobile";
import flowerPot from "@assets/images/evergreen-flower-pot.svg";

export default function MainContainer({
  backButtonPath,
  children,
  step,
  noBgForContainer = false,
  noBottomImage = false,
  showFlowerPot = false,
  padding,
  backButtonPadding,
  backButtonFunction,
}: React.PropsWithChildren<IContainerWithBackButton>) {
  const location = useLocation();
  const currentPath: string | any = location.pathname;
  const pathsNotToShowProductOverview = [
    ROUTE_PATH.EVER_GREEN_CONTACTUS,
    ROUTE_PATH.EVER_GREEN_GET_STARTED,
    ROUTE_PATH.EVER_GREEN_QUOTATION,
    ROUTE_PATH.EVER_GREEN_THANK_YOU,
    ROUTE_PATH.EVER_GREEN_VIEW_QUOTE,
  ];
  const currentPathTrimmed = currentPath?.endsWith("/")
    ? currentPath?.slice(0, -1)
    : currentPath || "";
  const enableProductOverView =
    !pathsNotToShowProductOverview.includes(currentPathTrimmed);

  const stepIndex =
    step && step > 0 && step <= STEPS_LIST.length ? step - 1 : 0;
  return (
    <>
      <Container
        noStepper={step ? false : true}
        showProductView={enableProductOverView}
        noBgForContainer={noBgForContainer}
        padding={padding}
      >
        <div className={`child`}>
          {(backButtonPath || backButtonFunction) && (
            <div className="back-btn">
              <BackButton padding={backButtonPadding}>
                {backButtonPath && (
                  <Link
                    to={backButtonPath}
                    style={{
                      color: "#000000",
                      fontWeight: 600,
                      fontSize: "16px",
                    }}
                  >
                    <Icon name="back-arrow"></Icon> Back
                  </Link>
                )}
                {backButtonFunction && (
                  <span
                    onClick={backButtonFunction}
                    style={{
                      color: "#000000",
                      fontWeight: 600,
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "10px",
                      fontSize: "16px",
                    }}
                  >
                    <Icon name="back-arrow"></Icon> Back
                  </span>
                )}
              </BackButton>
            </div>
          )}

          <div>{children}</div>
          {enableProductOverView && <ProductOverviewMobile />}
        </div>
        {/* {!noBottomImage && (
          <BgBottomImage enableProductOverView={enableProductOverView} >
            <img src={BgTree} alt="background" />
          </BgBottomImage>
        )} */}
        {showFlowerPot && (
          <PotContainer>
            <img src={flowerPot} alt="money plant" />
          </PotContainer>
        )}
      </Container>
      {step && (
        <Stepper
          steps={EVER_GREEN_STEP_LIST}
          activeId={EVER_GREEN_STEP_LIST[stepIndex].id}
        ></Stepper>
      )}
    </>
  );
}

const PotContainer = styled.div`
  position: absolute;
  display: none;
  bottom: 0;
  left: 0;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    display: block;
  }
`;
interface IContainerWithBackButton {
  backButtonFunction?: React.MouseEventHandler | null;
  backButtonPath?: string;
  step?: number;
  noBgForContainer?: boolean;
  showFlowerPot?: boolean;
  noBottomImage?: boolean;
  padding?: string;
  backButtonPadding?: string;
}
const BgBottomImage = styled.div<{ enableProductOverView: boolean }>`
  position: absolute;
  z-index: 0;
  bottom: ${(prop) => (prop.enableProductOverView ? "125px" : "0")};
  width: 100%;
  img {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    bottom: 0;
  }
`;
const BackButton = styled.div<{ padding?: string }>`
  padding: ${({ padding }) => (padding !== undefined ? `${padding}` : "0px")};
  margin-bottom: 24px;
  a {
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 10px;
    width: fit-content;
  }
  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    margin-bottom: 64px;
  }
`;

const Container = styled.div<{
  noStepper?: boolean;
  showProductView?: boolean;
  noBgForContainer?: boolean;
  padding?: string;
}>`
  position: relative;
  z-index: 2;
  margin: 0 auto;
  margin-top: ${({ noStepper }) => (noStepper ? "unset" : "100px")};
  height: 100%;
  display: flex;
  justify-content: center;
  padding-top: ${({ noStepper }) => (noStepper ? "0" : "98px")};
  padding: ${({ padding }) => (padding !== undefined ? `${padding}` : "24px")};
  color: #434343;
  min-height: calc(100vh - 200px);
  background-color: ${(props) => (props.noBgForContainer ? "" : "#F4F6F9")};
  .child {
    z-index: 3;
    margin-bottom: 50px;
    width: 100%;
  }

  @media screen and (max-width: 767px) {
    .child {
      margin-bottom: 130px;
    }
  }

  @media (min-width: 950px) {
    padding-top: ${({ noStepper }) => (noStepper ? "24px" : "124PX")};
    margin-bottom: 0;
    margin-top: 20px;
    .back-btn {
      position: absolute;
      left: -110px;
    }
    .child {
      flex: 1;
      position: relative;
      z-index: 3;
      margin-bottom: 100px;
      max-width: ${CONTAINER_SIZE.desktops}px;
    }
  }

  @media (min-width: 1100px) {
    min-height: calc(100vh - 50px);

    .back-btn {
      position: absolute;
      left: -156px;
    }
    .child {
      flex: 1;
      position: relative;
      max-width: ${CONTAINER_SIZE.desktops}px;
    }
  }

  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    padding-top: 64px;
  }
`;
